import { injectable } from 'inversify';
import { DevicesDetectionConfig } from '../models';
import { DeviceDetector } from './services.types';

@injectable()
export class ScreenWidthDeviceDetector implements DeviceDetector {
  detect(devicesDetectionConfig: DevicesDetectionConfig): string {
    return Object.entries(devicesDetectionConfig.screenWidth)
      .sort(this.sortByScreenWidthAscending)
      .find(this.selectByScreenWidth)[0];
  }

  private sortByScreenWidthAscending([deviceName1, width1]: any, [deviceName2, width2]: any): number {
    return width1 - width2;
  }

  private selectByScreenWidth([deviceName, targetWidth]: any): boolean {
    return window.innerWidth < targetWidth;
  }
}
